import { SvgIcon, useTheme } from '@material-ui/core';
import React from 'react';

export function ArgusIcon(): JSX.Element {
  return (
    <SvgIcon htmlColor="#FF414B" style={{ height: 22, width: 22 }}>
      <ArgusLogoSvg />
    </SvgIcon>
  );
}

export function ArgusLogoSvg(): JSX.Element {
	const theme = useTheme();
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px" y="0px"
      width="100%" viewBox="0 0 574 574" enableBackground="new 0 0 574 574"
		>
			<path fill={theme.palette.navigation.background} opacity="1.000000" stroke="none"
				d="
			M364.000000,575.000000
				C242.666672,575.000000 121.833336,575.000000 1.000000,575.000000
				C1.000000,383.666656 1.000000,192.333328 1.000000,1.000000
				C192.333328,1.000000 383.666656,1.000000 575.000000,1.000000
				C575.000000,192.333328 575.000000,383.666656 575.000000,575.000000
				C504.833344,575.000000 434.666656,575.000000 364.000000,575.000000
			M208.640442,413.529358
				C210.093002,413.664215 211.545563,413.799042 213.653595,414.094727
				C214.101654,414.095490 214.549698,414.096252 215.735748,414.478821
				C220.489426,414.930542 225.243103,415.382263 230.915237,416.038086
				C248.046509,416.496643 265.170563,416.820007 282.993439,413.332275
				C286.306702,413.366943 289.619934,413.401611 293.399109,413.713196
				C293.933868,413.743774 294.468658,413.774323 295.655945,413.972504
				C296.103394,413.963745 296.550842,413.954987 297.760223,414.235413
				C311.845184,414.842316 325.930115,415.449249 340.892700,416.212402
				C344.264557,415.881683 347.636414,415.550964 351.810486,415.278442
				C352.876007,415.165863 353.941528,415.053314 355.496643,415.019714
				C355.496643,415.019714 355.977966,414.900146 356.828461,414.951050
				C378.589081,412.587769 399.700684,407.336243 420.188690,399.814697
				C449.436310,389.077301 476.333191,373.988770 501.052216,354.967590
				C524.302551,337.076599 544.624451,316.423248 561.740112,292.565399
				C564.537781,288.665741 565.054138,286.008759 561.951904,281.858185
				C549.871338,265.695312 537.179321,250.129517 522.282471,236.436096
				C502.339233,218.103973 480.773407,202.091660 455.968018,189.390305
				C445.968323,184.962341 435.968597,180.534393 425.401245,175.675247
				C406.862244,168.282806 387.782196,162.520172 368.019043,159.973145
				C354.806549,158.270370 341.336304,158.567902 327.090485,157.850723
				C321.948547,158.517258 316.806610,159.183777 311.664642,159.850296
				C311.735046,160.355804 311.805420,160.861313 311.875793,161.366806
				C317.323242,161.068161 322.770660,160.769516 328.941681,160.535370
				C336.316254,160.679642 343.695892,160.796295 350.653076,163.226715
				C350.578125,163.683441 350.503143,164.140152 350.428192,164.596863
				C344.045868,164.596863 337.663574,164.596863 330.436798,164.334976
				C327.448273,164.662735 324.459747,164.990509 321.471252,165.318283
				C321.510040,165.572495 321.548828,165.826691 321.587646,166.080902
				C324.725311,166.080902 327.862976,166.080902 331.681152,166.207275
				C332.778656,166.539032 333.876129,166.870789 334.527740,167.681305
				C333.684113,168.153610 332.765381,168.530533 332.015045,169.121307
				C330.972015,169.942551 330.055206,170.924118 329.084381,171.837067
				C330.216675,172.625732 331.277649,173.568253 332.510559,174.139908
				C333.152649,174.437622 334.097931,174.081360 335.555145,174.504135
				C340.708618,174.994766 345.862091,175.485413 351.770111,176.167526
				C354.182037,176.670959 356.628479,177.048431 359.000488,177.697708
				C378.338074,182.990768 397.661774,188.334625 417.626617,193.978729
				C418.754272,194.312698 419.881927,194.646652 421.570648,195.376831
				C429.378571,198.875656 437.186523,202.374466 445.519623,206.323654
				C481.609497,225.636932 513.085449,250.488342 538.227051,283.066864
				C540.695068,286.265015 540.521240,288.193390 538.125000,291.127808
				C516.788452,317.257172 492.082062,339.508636 463.253052,357.146912
				C436.463562,373.537384 407.538147,384.496033 376.169769,391.581757
				C370.695923,392.547913 365.222046,393.514069 359.129547,394.470947
				C358.753235,394.631378 358.376923,394.791779 357.166229,394.924072
				C354.094910,395.318848 351.023560,395.713654 347.199005,396.015686
				C345.122925,396.259369 343.046844,396.503052 340.246918,396.570465
				C338.506012,396.692932 336.765106,396.815399 334.308899,396.768921
				C331.866821,396.833618 329.424713,396.898346 326.330536,396.807343
				C325.889954,396.860596 325.449371,396.913818 324.262512,396.785767
				C322.165283,396.750305 320.068024,396.714844 317.135712,396.403870
				C315.088959,396.274292 313.042206,396.144714 310.956818,395.614288
				C310.956818,395.614288 310.868256,395.221497 311.540894,394.875061
				C313.499420,394.835236 315.524414,395.102936 317.403748,394.696747
				C322.614807,393.570343 327.765167,392.163330 333.507843,390.670715
				C334.018646,390.362610 334.529480,390.054535 335.746246,389.667847
				C338.517395,388.312195 341.288544,386.956573 344.690063,385.228699
				C364.712738,372.641052 380.321808,355.835327 391.371429,335.019775
				C403.102692,312.920105 406.218018,289.263123 400.673950,264.960358
				C394.007629,235.737961 377.484650,212.701340 353.265167,194.169434
				C349.172272,191.227493 345.079346,188.285538 340.590302,184.911682
				C339.047638,183.981339 337.505005,183.051010 335.509857,181.605881
				C332.394836,179.872055 329.279846,178.138229 325.671417,176.016190
				C324.152252,175.243652 322.633118,174.471100 320.583588,173.270569
				C316.048218,171.543945 311.512878,169.817322 306.401031,167.619095
				C304.974701,167.197342 303.548340,166.775589 301.517426,166.033188
				C296.337738,164.718521 291.158081,163.403839 285.360535,161.793442
				C284.236877,161.648453 283.113190,161.503448 281.221558,161.080750
				C265.299225,157.790924 249.236023,156.581894 232.409851,157.699646
				C231.619278,157.828308 230.828720,157.956970 229.115875,157.966858
				C222.827148,158.682861 216.515533,159.242554 210.256226,160.159393
				C204.155930,161.052917 198.109116,162.311722 191.349197,163.326447
				C190.257690,163.628006 189.166183,163.929581 187.262863,164.280350
				C183.849319,165.024887 180.388885,165.601654 177.029556,166.540192
				C147.283249,174.850754 119.591995,187.713333 93.834274,204.685760
				C62.217686,225.518768 35.296894,251.268753 13.157508,282.050934
				C10.265200,286.072327 10.685072,288.705048 13.425993,292.389465
				C27.294628,311.031952 42.571743,328.397980 60.239330,343.492584
				C74.501953,355.678162 89.047424,367.582520 106.409058,376.564270
				C108.136200,377.462189 109.863342,378.360107 112.023804,379.758606
				C113.567787,380.559265 115.111771,381.359955 117.081573,382.649445
				C118.053886,383.101227 119.026192,383.552979 120.534538,384.448853
				C131.007874,389.017120 141.481201,393.585388 152.404175,398.619812
				C153.230896,398.848907 154.057617,399.078003 155.407394,399.797699
				C164.957413,402.636383 174.507416,405.475037 184.669434,408.712189
				C192.443192,410.203033 200.216965,411.693878 208.640442,413.529358
			z"/>
			<path fill="#A8B0B0" opacity="1.000000" stroke="none"
				d="
			M310.995453,396.015106
				C313.042206,396.144714 315.088959,396.274292 317.594788,396.879822
				C319.178467,398.475128 320.303101,399.594482 321.427734,400.713837
				C322.621429,399.464905 323.815094,398.216003 325.008789,396.967072
				C325.449371,396.913818 325.889954,396.860596 327.006378,397.029877
				C330.129547,397.147552 332.576874,397.042694 335.024200,396.937866
				C336.765106,396.815399 338.506012,396.692932 340.722229,396.952209
				C343.286255,400.644073 346.141785,401.073669 350.060699,399.668060
				C349.232391,398.269623 348.592316,397.189026 347.952240,396.108398
				C351.023560,395.713654 354.094910,395.318848 357.637573,395.274536
				C359.293396,396.596313 360.477875,397.567566 361.662354,398.538849
				C361.984802,398.025208 362.307251,397.511597 362.629700,396.997955
				C361.669220,396.158722 360.708710,395.319489 359.748199,394.480225
				C365.222046,393.514069 370.695923,392.547913 376.475586,391.914673
				C376.381805,393.668762 375.612396,395.100403 375.652222,396.509094
				C375.769379,400.649811 374.041290,401.732025 370.116669,400.892792
				C368.830780,400.617828 367.084320,401.580780 365.803223,402.384003
				C362.836700,404.243866 360.208313,406.721832 357.100616,408.255920
				C353.946198,409.813080 351.230865,411.298981 351.008270,415.220276
				C347.636414,415.550964 344.264557,415.881683 340.484589,415.793457
				C340.876587,410.073120 336.708771,409.602142 333.451111,409.414978
				C321.389740,408.722046 309.303894,408.428070 297.224182,408.097015
				C293.691925,408.000183 291.906433,409.682343 292.933197,413.436310
				C289.619934,413.401611 286.306702,413.366943 282.436462,412.949646
				C280.502838,411.072113 279.217255,408.395538 277.734222,408.281281
				C270.233276,407.703278 262.574371,405.281372 255.207474,409.289215
				C253.857620,410.023621 252.008286,410.255096 250.445175,410.111725
				C242.896317,409.419342 235.374313,408.435089 227.825943,407.736328
				C224.959778,407.471008 222.048508,407.693237 219.157791,407.693237
				C218.997757,408.245361 218.837723,408.797516 218.677689,409.349640
				C220.978043,410.661987 223.279739,411.971924 225.578217,413.287537
				C227.053558,414.131989 228.524094,414.984863 229.996780,415.833954
				C225.243103,415.382263 220.489426,414.930542 215.306702,413.918762
				C214.070221,409.190399 211.946671,406.317444 207.372467,406.147003
				C199.586121,405.856842 191.795929,405.670166 183.663788,405.429840
				C183.720520,405.845459 183.888977,407.079590 184.057434,408.313721
				C174.507416,405.475037 164.957413,402.636383 155.122223,399.231659
				C154.445770,397.891418 154.054504,397.117218 153.663239,396.343018
				C153.093658,396.946564 152.524094,397.550110 151.954529,398.153656
				C141.481201,393.585388 131.007874,389.017120 120.302673,383.978241
				C118.932457,383.058655 117.794098,382.609650 116.655746,382.160645
				C115.111771,381.359955 113.567787,380.559265 112.009308,379.220764
				C111.855087,376.977448 111.715355,375.271912 111.575623,373.566406
				C109.709625,374.403198 107.843628,375.239960 105.977623,376.076752
				C89.047424,367.582520 74.501953,355.678162 60.239330,343.492584
				C42.571743,328.397980 27.294628,311.031952 13.425993,292.389465
				C10.685072,288.705048 10.265200,286.072327 13.157508,282.050934
				C35.296894,251.268753 62.217686,225.518768 93.834274,204.685760
				C119.591995,187.713333 147.283249,174.850754 177.029556,166.540192
				C180.388885,165.601654 183.849319,165.024887 187.871094,164.431458
				C189.665833,164.191772 190.852341,163.800964 192.038834,163.410156
				C198.109116,162.311722 204.155930,161.052917 210.256226,160.159393
				C216.515533,159.242554 222.827148,158.682861 229.789612,158.114807
				C231.311356,158.114243 232.159378,157.965714 233.007385,157.817184
				C249.236023,156.581894 265.299225,157.790924 281.624878,161.534637
				C282.541504,162.933929 283.054840,163.879333 283.568176,164.824738
				C284.371582,163.912888 285.174988,163.001022 285.978394,162.089172
				C291.158081,163.403839 296.337738,164.718521 301.895447,166.537994
				C303.275543,169.932571 304.856384,170.224350 306.977509,168.090683
				C311.512878,169.817322 316.048218,171.543945 320.866089,173.860779
				C321.943970,175.906586 322.739380,177.362183 323.534790,178.817780
				C324.411469,178.013306 325.288147,177.208847 326.164825,176.404388
				C329.279846,178.138229 332.394836,179.872055 335.773621,182.232437
				C336.893494,184.524307 337.749664,186.189621 338.605835,187.854919
				C339.399353,187.017792 340.192902,186.180695 340.986450,185.343597
				C345.079346,188.285538 349.172272,191.227493 353.075806,194.539581
				C351.413605,195.829575 349.508698,196.430359 348.549469,197.729446
				C345.751709,201.518524 343.331787,205.586594 340.452881,209.384064
				C337.339935,207.190750 334.537872,205.158676 331.955139,202.908859
				C332.152771,201.414413 332.131073,200.137695 332.109406,198.860992
				C329.976685,198.954025 327.843994,199.047043 325.379578,199.055252
				C321.368652,196.899185 317.689484,194.827957 314.145844,192.487183
				C315.623230,189.986343 315.420807,188.188950 312.816681,187.093292
				C309.973969,185.897247 308.499451,187.195984 307.417236,189.783447
				C304.023102,188.483765 301.010712,187.277130 297.962250,185.695618
				C297.495087,181.948471 295.983704,179.224625 292.364319,179.108231
				C291.585175,179.083191 290.711700,181.992249 289.468719,183.488342
				C286.379730,183.649750 283.703735,183.872543 280.908691,183.786423
				C277.474457,180.654572 277.011353,180.901459 275.701355,186.230881
				C267.358459,190.201996 259.314850,193.972824 251.155914,197.404724
				C249.872070,196.433350 248.703506,195.800934 247.534943,195.168503
				C248.040894,196.453125 248.546844,197.737732 248.834976,199.280792
				C240.163361,205.861450 231.709579,212.183655 223.044159,218.275024
				C219.098206,215.318680 217.717361,219.149048 215.690704,220.828751
				C215.511871,220.976990 216.947876,223.073547 217.484253,224.584656
				C214.417526,228.328262 211.500397,231.752396 208.292664,235.257416
				C207.537170,236.333130 207.072311,237.327957 206.472931,238.652924
				C199.780685,249.588379 195.348618,261.053741 192.162933,273.221436
				C187.758514,275.714844 187.769012,276.469818 191.925293,279.469177
				C191.956177,285.624451 191.958221,291.312164 191.704468,297.195618
				C188.921814,300.139465 188.703339,302.225220 193.218292,303.351685
				C194.109482,306.809814 194.840027,309.915100 195.208527,313.134094
				C191.539536,314.666138 191.688461,317.237030 193.017487,319.781708
				C194.285019,322.208649 196.091431,324.226929 199.547638,322.740295
				C200.595581,324.824402 201.414185,326.655426 202.093979,328.883301
				C199.954422,338.302460 203.122986,342.585083 212.337250,343.133270
				C213.463181,344.400269 214.334442,345.502289 215.085739,346.956421
				C216.213455,352.064087 217.461105,356.819641 218.947861,362.486572
				C215.824463,362.002808 212.203857,362.448059 210.069473,360.875763
				C206.863647,358.514130 204.646469,359.718475 201.693848,360.849915
				C199.053467,357.573090 196.711166,354.449402 194.520416,351.077545
				C195.563828,348.441498 194.831787,347.778503 192.262863,348.549194
				C184.239059,337.277924 178.280579,325.425323 175.767517,312.039673
				C179.173676,308.829742 178.866333,307.989990 173.756042,305.645325
				C173.106415,301.193390 172.620956,297.097687 172.467987,292.885406
				C177.392700,288.921936 177.091568,283.770752 172.017944,279.578796
				C172.925659,273.747986 173.869492,268.339294 175.113724,262.882751
				C176.104507,262.301575 176.794891,261.768188 177.485260,261.234802
				C176.846664,260.823090 176.208084,260.411438 175.567047,259.601807
				C179.046906,247.309082 183.939102,236.097809 191.804321,226.328232
				C195.509491,226.718323 195.198242,224.839722 194.389114,222.272644
				C197.391190,218.493362 200.248581,215.036346 203.508087,211.580063
				C206.798264,211.112198 209.862534,210.787567 208.256973,206.198303
				C213.515167,201.630630 218.583115,197.357346 223.815933,193.340378
				C226.521225,194.853394 226.619904,194.752197 227.074921,190.383224
				C232.739700,186.371780 238.198547,182.611481 243.657394,178.851181
				C243.522186,178.526642 243.386963,178.202103 243.251755,177.877563
				C237.501923,177.877563 231.752090,177.877563 225.911133,177.544189
				C224.523666,176.308334 223.227341,175.405869 221.931000,174.503403
				C221.008240,175.839096 220.085464,177.174805 218.794434,178.663208
				C215.997574,179.055725 213.568985,179.295532 210.966217,179.275696
				C208.821060,176.831299 207.781509,177.986023 206.643250,180.230774
				C179.592682,185.150909 154.123383,193.619934 130.077972,206.129288
				C93.850349,224.976334 63.208088,250.631027 37.586075,282.421631
				C34.638454,286.078888 34.937923,288.188721 37.635715,291.639954
				C53.603939,312.067841 72.740128,329.164703 93.105072,345.447937
				C95.116806,346.856354 97.021011,347.941010 99.255302,349.140869
				C106.389145,353.507263 113.192909,357.758514 120.035294,362.381104
				C121.712387,368.006012 122.791138,368.519165 127.348007,366.095215
				C145.207626,373.169281 162.710037,380.190857 180.263748,387.547729
				C181.281113,390.907196 182.499435,391.140045 184.399597,388.195038
				C191.554352,389.717804 198.312500,391.261871 205.112152,393.031067
				C205.375107,393.635010 205.596573,394.013763 205.818039,394.392548
				C206.214203,394.038086 206.610367,393.683624 207.423981,393.285706
				C212.226654,393.871887 216.611893,394.501495 221.029144,395.489624
				C221.956329,397.242950 222.851486,398.637787 223.746643,400.032593
				C224.505737,398.550751 225.264847,397.068909 226.441193,395.493408
				C232.593552,395.653931 238.328659,395.908112 244.195770,396.180389
				C244.304840,395.803009 244.281921,395.407532 243.952271,394.895630
				C242.407272,393.912170 241.169006,393.045197 240.008331,391.826843
				C239.466537,389.422638 239.367661,386.962524 238.136200,385.388580
				C233.227295,379.114502 227.965683,373.116425 222.834625,367.016174
				C223.138382,366.456421 223.442139,365.896698 223.745895,365.336945
				C225.792923,366.271545 228.070999,366.895233 229.837173,368.207764
				C233.151199,370.670563 236.262863,372.461700 240.246201,369.109131
				C241.722534,370.074921 242.893845,370.952545 244.001694,372.166107
				C244.107498,378.278381 251.036743,381.904419 256.395813,378.915710
				C259.495758,380.416016 262.244507,381.837799 265.019165,383.622559
				C265.933319,385.422333 266.821564,386.859100 267.709839,388.295898
				C268.800720,387.561127 269.891602,386.826355 271.355896,386.127930
				C275.485352,387.482666 279.241394,388.801056 283.019043,390.505249
				C283.038574,394.391357 285.072998,395.776794 288.283783,396.196381
				C290.942444,396.543854 293.315338,396.672577 294.420471,393.238434
				C296.233856,393.320892 297.628143,393.456726 299.328094,393.783630
				C302.418304,394.420837 305.202881,394.867004 307.941772,395.571442
				C308.198669,396.596252 308.501312,397.362762 308.803925,398.129272
				C309.534454,397.424561 310.264954,396.719849 310.995453,396.015106
			M231.694153,175.131058
				C232.220505,175.167496 232.746841,175.203918 233.273209,175.240356
				C233.282349,175.091690 233.291489,174.943039 233.300613,174.794357
				C232.772141,174.802048 232.243668,174.809738 231.694153,175.131058
			M241.921417,199.736679
				C242.036148,199.657257 242.150864,199.577835 242.265564,199.498428
				C242.158600,199.407043 242.051636,199.315659 241.944702,199.224274
				C241.896484,199.358887 241.848267,199.493484 241.921417,199.736679
			M345.944489,194.960159
				C345.944489,194.960159 345.994141,194.920441 345.944489,194.960159
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M351.409363,415.249359
				C351.230865,411.298981 353.946198,409.813080 357.100616,408.255920
				C360.208313,406.721832 362.836700,404.243866 365.803223,402.384003
				C367.084320,401.580780 368.830780,400.617828 370.116669,400.892792
				C374.041290,401.732025 375.769379,400.649811 375.652222,396.509094
				C375.612396,395.100403 376.381805,393.668762 376.913208,391.908325
				C407.538147,384.496033 436.463562,373.537384 463.253052,357.146912
				C492.082062,339.508636 516.788452,317.257172 538.125000,291.127808
				C540.521240,288.193390 540.695068,286.265015 538.227051,283.066864
				C513.085449,250.488342 481.609497,225.636932 445.074707,205.827484
				C443.479492,204.397537 442.079498,203.642624 441.247314,202.480942
				C440.370056,201.256332 440.034912,199.643341 439.462891,198.200043
				C441.248322,198.364166 443.894226,197.832474 444.680450,198.804657
				C450.034119,205.424789 457.378815,205.794601 464.871857,205.871094
				C465.767334,205.880234 466.670258,205.160477 466.705414,205.145554
				C464.267853,203.395706 461.904327,201.640274 459.465179,199.997131
				C458.971222,199.664383 458.179016,199.617905 457.545502,199.674973
				C454.268555,199.970139 451.861267,198.921051 451.437958,195.385712
				C451.001373,191.739334 453.430115,190.436584 456.511047,189.874069
				C480.773407,202.091660 502.339233,218.103973 522.282471,236.436096
				C537.179321,250.129517 549.871338,265.695312 561.951904,281.858185
				C565.054138,286.008759 564.537781,288.665741 561.740112,292.565399
				C544.624451,316.423248 524.302551,337.076599 501.052216,354.967590
				C476.333191,373.988770 449.436310,389.077301 420.188690,399.814697
				C399.700684,407.336243 378.589081,412.587769 356.281525,414.915527
				C355.489868,414.870819 355.247375,414.891052 355.007050,414.940735
				C353.941528,415.053314 352.876007,415.165863 351.409363,415.249359
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M340.763733,209.545288
				C343.331787,205.586594 345.751709,201.518524 348.549469,197.729446
				C349.508698,196.430359 351.413605,195.829575 353.288330,194.820251
				C377.484650,212.701340 394.007629,235.737961 400.673950,264.960358
				C406.218018,289.263123 403.102692,312.920105 391.371429,335.019775
				C380.321808,355.835327 364.712738,372.641052 344.199310,385.077972
				C340.206268,383.695923 336.778381,382.141144 333.183105,381.313934
				C328.528473,380.242981 323.740326,379.752350 319.272308,378.800201
				C337.829407,367.652527 354.277069,354.688171 366.845276,337.134186
				C389.099426,306.051788 388.913666,264.936554 365.297119,234.931183
				C358.056396,225.731659 348.992676,217.967010 340.763733,209.545288
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M327.981384,157.970291
				C341.336304,158.567902 354.806549,158.270370 368.019043,159.973145
				C387.782196,162.520172 406.862244,168.282806 425.640717,176.261505
				C424.132812,178.201340 422.552063,180.262466 420.594452,180.723587
				C418.314301,181.260681 415.698242,180.143311 413.239105,180.203033
				C409.660309,180.289948 404.814606,179.448029 402.781952,181.386047
				C398.439514,185.526276 395.103333,183.419769 391.155243,181.848694
				C386.282166,179.909531 381.346191,178.128510 376.072784,176.241272
				C372.876099,175.334656 370.091248,174.238953 367.203491,173.637650
				C356.478546,171.404510 345.719727,169.334076 334.973633,167.202545
				C333.876129,166.870789 332.778656,166.539032 331.379669,165.895111
				C331.145874,165.254242 331.213562,164.925552 331.281250,164.596863
				C337.663574,164.596863 344.045868,164.596863 350.428192,164.596863
				C350.503143,164.140152 350.578125,163.683441 350.653076,163.226715
				C343.695892,160.796295 336.316254,160.679642 328.550507,160.190125
				C328.100037,159.220032 328.040710,158.595154 327.981384,157.970291
			z"/>
			<path fill="#A8B0B0" opacity="1.000000" stroke="none"
				d="
			M376.437378,176.279144
				C381.346191,178.128510 386.282166,179.909531 391.155243,181.848694
				C395.103333,183.419769 398.439514,185.526276 402.781952,181.386047
				C404.814606,179.448029 409.660309,180.289948 413.239105,180.203033
				C415.698242,180.143311 418.314301,181.260681 420.594452,180.723587
				C422.552063,180.262466 424.132812,178.201340 425.924561,176.477097
				C435.968597,180.534393 445.968323,184.962341 456.239532,189.632187
				C453.430115,190.436584 451.001373,191.739334 451.437958,195.385712
				C451.861267,198.921051 454.268555,199.970139 457.545502,199.674973
				C458.179016,199.617905 458.971222,199.664383 459.465179,199.997131
				C461.904327,201.640274 464.267853,203.395706 466.705414,205.145554
				C466.670258,205.160477 465.767334,205.880234 464.871857,205.871094
				C457.378815,205.794601 450.034119,205.424789 444.680450,198.804657
				C443.894226,197.832474 441.248322,198.364166 439.462891,198.200043
				C440.034912,199.643341 440.370056,201.256332 441.247314,202.480942
				C442.079498,203.642624 443.479492,204.397537 444.812134,205.602295
				C437.186523,202.374466 429.378571,198.875656 421.591248,195.107224
				C423.084717,194.661011 424.862915,194.918167 425.930878,194.166367
				C426.740509,193.596390 427.044342,190.669968 426.893951,190.613876
				C423.168121,189.224548 419.443665,186.643173 414.842163,189.853226
				C415.602142,191.201492 416.295929,192.432251 416.989685,193.663010
				C397.661774,188.334625 378.338074,182.990768 359.000488,177.697708
				C356.628479,177.048431 354.182037,176.670959 351.366699,175.746918
				C350.980896,174.892334 350.998505,174.458344 351.432556,174.056305
				C359.721497,175.671753 367.589478,177.278748 375.474762,178.795929
				C376.135712,178.923141 376.912842,178.446381 377.636017,178.250214
				C377.236450,177.593201 376.836914,176.936172 376.437378,176.279144
			M434.884521,182.898682
				C434.095306,182.710464 433.306122,182.522232 432.516907,182.334000
				C432.479584,182.909943 432.442261,183.485870 432.404968,184.061798
				C433.217133,183.827393 434.029327,183.592972 434.884521,182.898682
			M447.080292,190.468369
				C447.687500,190.601898 448.294708,190.735443 448.901917,190.868973
				C448.906616,190.432068 448.911316,189.995163 448.916046,189.558243
				C448.309631,189.724426 447.703217,189.890625 447.080292,190.468369
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M230.456009,415.936035
				C228.524094,414.984863 227.053558,414.131989 225.578217,413.287537
				C223.279739,411.971924 220.978043,410.661987 218.677689,409.349640
				C218.837723,408.797516 218.997757,408.245361 219.157791,407.693237
				C222.048508,407.693237 224.959778,407.471008 227.825943,407.736328
				C235.374313,408.435089 242.896317,409.419342 250.445175,410.111725
				C252.008286,410.255096 253.857620,410.023621 255.207474,409.289215
				C262.574371,405.281372 270.233276,407.703278 277.734222,408.281281
				C279.217255,408.395538 280.502838,411.072113 281.984375,412.934601
				C265.170563,416.820007 248.046509,416.496643 230.456009,415.936035
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M293.166138,413.574768
				C291.906433,409.682343 293.691925,408.000183 297.224182,408.097015
				C309.303894,408.428070 321.389740,408.722046 333.451111,409.414978
				C336.708771,409.602142 340.876587,410.073120 340.045776,415.715332
				C325.930115,415.449249 311.845184,414.842316 297.267700,413.944336
				C296.184601,413.703796 295.593994,413.754364 295.003418,413.804871
				C294.468658,413.774323 293.933868,413.743774 293.166138,413.574768
			z"/>
			<path fill="#4C5053" opacity="1.000000" stroke="none"
				d="
			M307.987457,395.313171
				C305.202881,394.867004 302.418304,394.420837 299.122223,393.555695
				C296.616699,391.096954 296.809906,389.423523 299.413818,388.098999
				C301.323517,387.127533 303.206085,386.102692 305.315308,385.361084
				C309.595612,386.741394 313.609100,388.143219 317.740448,388.910858
				C322.754852,389.842621 327.868683,390.239105 332.939514,390.867188
				C327.765167,392.163330 322.614807,393.570343 317.403748,394.696747
				C315.524414,395.102936 313.499420,394.835236 310.842712,395.018860
				C309.425476,395.212830 308.706482,395.263000 307.987457,395.313171
			z"/>
			<path fill="#434749" opacity="1.000000" stroke="none"
				d="
			M376.072784,176.241272
				C376.836914,176.936172 377.236450,177.593201 377.636017,178.250214
				C376.912842,178.446381 376.135712,178.923141 375.474762,178.795929
				C367.589478,177.278748 359.721497,175.671753 351.028046,173.937073
				C345.152832,173.523056 340.098511,173.260239 334.940399,172.871979
				C334.580170,172.660690 334.323792,172.574860 334.067383,172.489029
				C334.115601,172.603439 334.144348,172.801071 334.215424,172.817673
				C334.503906,172.885117 334.805359,172.896957 335.058624,173.203094
				C334.978912,173.658066 334.942596,173.839279 334.906281,174.020477
				C334.097931,174.081360 333.152649,174.437622 332.510559,174.139908
				C331.277649,173.568253 330.216675,172.625732 329.084381,171.837067
				C330.055206,170.924118 330.972015,169.942551 332.015045,169.121307
				C332.765381,168.530533 333.684113,168.153610 334.750671,167.441925
				C345.719727,169.334076 356.478546,171.404510 367.203491,173.637650
				C370.091248,174.238953 372.876099,175.334656 376.072784,176.241272
			z"/>
			<path fill="#7B807E" opacity="1.000000" stroke="none"
				d="
			M319.009644,379.011871
				C323.740326,379.752350 328.528473,380.242981 333.183105,381.313934
				C336.778381,382.141144 340.206268,383.695923 343.884125,385.264099
				C341.288544,386.956573 338.517395,388.312195 335.270386,389.387573
				C333.136108,388.222046 331.565430,387.057526 329.802826,386.503998
				C324.563477,384.858612 319.248657,383.453583 314.184113,381.716064
				C315.939789,380.655640 317.474701,379.833740 319.009644,379.011871
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M184.363434,408.512939
				C183.888977,407.079590 183.720520,405.845459 183.663788,405.429840
				C191.795929,405.670166 199.586121,405.856842 207.372467,406.147003
				C211.946671,406.317444 214.070221,409.190399 214.937714,413.727844
				C214.549698,414.096252 214.101654,414.095490 213.220917,413.713409
				C211.286255,410.118805 209.696915,409.749756 207.990723,413.184723
				C200.216965,411.693878 192.443192,410.203033 184.363434,408.512939
			z"/>
			<path fill="#606363" opacity="1.000000" stroke="none"
				d="
			M313.963348,381.954590
				C319.248657,383.453583 324.563477,384.858612 329.802826,386.503998
				C331.565430,387.057526 333.136108,388.222046 334.917419,389.426880
				C334.529480,390.054535 334.018646,390.362610 333.223694,390.768951
				C327.868683,390.239105 322.754852,389.842621 317.740448,388.910858
				C313.609100,388.143219 309.595612,386.741394 305.654053,385.253540
				C308.506592,383.909210 311.234985,382.931915 313.963348,381.954590
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M417.308167,193.820862
				C416.295929,192.432251 415.602142,191.201492 414.842163,189.853226
				C419.443665,186.643173 423.168121,189.224548 426.893951,190.613876
				C427.044342,190.669968 426.740509,193.596390 425.930878,194.166367
				C424.862915,194.918167 423.084717,194.661011 421.310730,194.909119
				C419.881927,194.646652 418.754272,194.312698 417.308167,193.820862
			z"/>
			<path fill="#828689" opacity="1.000000" stroke="none"
				d="
			M327.535950,157.910507
				C328.040710,158.595154 328.100037,159.220032 328.188721,160.157867
				C322.770660,160.769516 317.323242,161.068161 311.875793,161.366806
				C311.805420,160.861313 311.735046,160.355804 311.664642,159.850296
				C316.806610,159.183777 321.948547,158.517258 327.535950,157.910507
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M106.193344,376.320496
				C107.843628,375.239960 109.709625,374.403198 111.575623,373.566406
				C111.715355,375.271912 111.855087,376.977448 111.792648,378.970490
				C109.863342,378.360107 108.136200,377.462189 106.193344,376.320496
			z"/>
			<path fill="#828689" opacity="1.000000" stroke="none"
				d="
			M335.230713,174.262299
				C334.942596,173.839279 334.978912,173.658066 335.042358,173.218964
				C335.069489,172.961060 335.044220,172.997421 335.044220,172.997421
				C340.098511,173.260239 345.152832,173.523056 350.611633,173.905106
				C350.998505,174.458344 350.980896,174.892334 350.989441,175.651184
				C345.862091,175.485413 340.708618,174.994766 335.230713,174.262299
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M347.575623,396.062042
				C348.592316,397.189026 349.232391,398.269623 350.060699,399.668060
				C346.141785,401.073669 343.286255,400.644073 341.084137,397.040344
				C343.046844,396.503052 345.122925,396.259369 347.575623,396.062042
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M324.635651,396.876404
				C323.815094,398.216003 322.621429,399.464905 321.427734,400.713837
				C320.303101,399.594482 319.178467,398.475128 318.012329,397.017578
				C320.068024,396.714844 322.165283,396.750305 324.635651,396.876404
			z"/>
			<path fill="#7B807E" opacity="1.000000" stroke="none"
				d="
			M330.859009,164.465912
				C331.213562,164.925552 331.145874,165.254242 331.039429,165.831909
				C327.862976,166.080902 324.725311,166.080902 321.587646,166.080902
				C321.548828,165.826691 321.510040,165.572495 321.471252,165.318283
				C324.459747,164.990509 327.448273,164.662735 330.859009,164.465912
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M340.788361,185.127625
				C340.192902,186.180695 339.399353,187.017792 338.605835,187.854919
				C337.749664,186.189621 336.893494,184.524307 335.999847,182.489838
				C337.505005,183.051010 339.047638,183.981339 340.788361,185.127625
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M325.918121,176.210297
				C325.288147,177.208847 324.411469,178.013306 323.534790,178.817780
				C322.739380,177.362183 321.943970,175.906586 321.131256,174.074768
				C322.633118,174.471100 324.152252,175.243652 325.918121,176.210297
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M359.438873,394.475586
				C360.708710,395.319489 361.669220,396.158722 362.629700,396.997955
				C362.307251,397.511597 361.984802,398.025208 361.662354,398.538849
				C360.477875,397.567566 359.293396,396.596313 358.054749,395.288605
				C358.376923,394.791779 358.753235,394.631378 359.438873,394.475586
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M285.669464,161.941315
				C285.174988,163.001022 284.371582,163.912888 283.568176,164.824738
				C283.054840,163.879333 282.541504,162.933929 282.008850,161.673492
				C283.113190,161.503448 284.236877,161.648453 285.669464,161.941315
			z"/>
			<path fill="#A8B0B0" opacity="1.000000" stroke="none"
				d="
			M208.315582,413.357056
				C209.696915,409.749756 211.286255,410.118805 212.893173,413.632996
				C211.545563,413.799042 210.093002,413.664215 208.315582,413.357056
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M334.666565,396.853394
				C332.576874,397.042694 330.129547,397.147552 327.332428,397.107727
				C329.424713,396.898346 331.866821,396.833618 334.666565,396.853394
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M306.689270,167.854889
				C304.856384,170.224350 303.275543,169.932571 302.197723,166.698334
				C303.548340,166.775589 304.974701,167.197342 306.689270,167.854889
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M307.941772,395.571472
				C308.706482,395.263000 309.425476,395.212830 310.506378,395.192078
				C310.868256,395.221497 310.956818,395.614288 310.976135,395.814697
				C310.264954,396.719849 309.534454,397.424561 308.803925,398.129272
				C308.501312,397.362762 308.198669,396.596252 307.941772,395.571472
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M152.179352,398.386719
				C152.524094,397.550110 153.093658,396.946564 153.663239,396.343018
				C154.054504,397.117218 154.445770,397.891418 154.860687,398.986389
				C154.057617,399.078003 153.230896,398.848907 152.179352,398.386719
			z"/>
			<path fill="#A0A7A7" opacity="1.000000" stroke="none"
				d="
			M191.694016,163.368301
				C190.852341,163.800964 189.665833,164.191772 188.277008,164.406860
				C189.166183,163.929581 190.257690,163.628006 191.694016,163.368301
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M116.868652,382.405029
				C117.794098,382.609650 118.932457,383.058655 120.034653,383.756195
				C119.026192,383.552979 118.053886,383.101227 116.868652,382.405029
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M232.708618,157.758423
				C232.159378,157.965714 231.311356,158.114243 230.250748,158.174194
				C230.828720,157.956970 231.619278,157.828308 232.708618,157.758423
			z"/>
			<path fill="#A8B0B0" opacity="1.000000" stroke="none"
				d="
			M295.329681,413.888702
				C295.593994,413.754364 296.184601,413.703796 296.886719,413.799744
				C296.550842,413.954987 296.103394,413.963745 295.329681,413.888702
			z"/>
			<path fill="#A8B0B0" opacity="1.000000" stroke="none"
				d="
			M355.251831,414.980225
				C355.247375,414.891052 355.489868,414.870819 355.856262,414.890076
				C355.977966,414.900146 355.496643,415.019714 355.251831,414.980225
			z"/>
			<path fill="#393B40" opacity="1.000000" stroke="none"
				d="
			M314.184113,381.716064
				C311.234985,382.931915 308.506592,383.909210 305.439453,384.994080
				C303.206085,386.102692 301.323517,387.127533 299.413818,388.098999
				C296.809906,389.423523 296.616699,391.096954 298.816589,393.364655
				C297.628143,393.456726 296.233856,393.320892 294.083557,393.066833
				C289.884216,392.005524 286.440826,391.062469 282.997467,390.119446
				C279.241394,388.801056 275.485352,387.482666 271.120697,385.892242
				C268.672485,384.833313 266.832886,384.046417 264.993286,383.259552
				C262.244507,381.837799 259.495758,380.416016 256.175079,378.665222
				C251.757156,376.167511 247.911148,373.998840 244.065155,371.830170
				C242.893845,370.952545 241.722534,370.074921 240.052429,368.840820
				C231.437653,361.191040 223.321671,353.897705 215.205688,346.604340
				C214.334442,345.502289 213.463181,344.400269 212.214508,342.815399
				C208.635651,337.717224 205.434219,333.101837 202.232788,328.486481
				C201.414185,326.655426 200.595581,324.824402 199.481537,322.400635
				C197.980927,318.878754 196.775757,315.949585 195.570587,313.020386
				C194.840027,309.915100 194.109482,306.809814 193.167114,302.972443
				C192.623642,300.493530 192.291946,298.746704 191.960266,296.999878
				C191.958221,291.312164 191.956177,285.624451 192.027725,279.061340
				C192.237198,276.511780 192.373077,274.837585 192.508972,273.163422
				C195.348618,261.053741 199.780685,249.588379 206.701462,238.438660
				C207.570755,236.988358 208.077011,236.082443 208.583282,235.176544
				C211.500397,231.752396 214.417526,228.328262 217.736176,224.410339
				C219.843719,222.112976 221.549744,220.309418 223.255768,218.505859
				C231.709579,212.183655 240.163361,205.861450 249.094528,199.242920
				C250.138351,198.545639 250.704788,198.144653 251.271225,197.743668
				C259.314850,193.972824 267.358459,190.201996 276.044373,186.207504
				C278.133667,185.354340 279.580688,184.724838 281.027710,184.095337
				C283.703735,183.872543 286.379730,183.649750 289.777496,183.644836
				C292.998932,184.598633 295.498627,185.334564 297.998322,186.070496
				C301.010712,187.277130 304.023102,188.483765 307.680725,189.933609
				C310.220703,191.036804 312.115509,191.896759 314.010284,192.756729
				C317.689484,194.827957 321.368652,196.899185 325.577484,199.324310
				C327.983337,200.827652 329.859589,201.977112 331.735809,203.126587
				C334.537872,205.158676 337.339935,207.190750 340.452881,209.384064
				C348.992676,217.967010 358.056396,225.731659 365.297119,234.931183
				C388.913666,264.936554 389.099426,306.051788 366.845276,337.134186
				C354.277069,354.688171 337.829407,367.652527 319.272308,378.800201
				C317.474701,379.833740 315.939789,380.655640 314.184113,381.716064
			z"/>
			<path fill="#393B40" opacity="1.000000" stroke="none"
				d="
			M226.002258,177.877563
				C231.752090,177.877563 237.501923,177.877563 243.251755,177.877563
				C243.386963,178.202103 243.522186,178.526642 243.657394,178.851181
				C238.198547,182.611481 232.739700,186.371780 226.798248,190.485031
				C225.427460,191.586670 224.539261,192.335373 223.651062,193.084076
				C218.583115,197.357346 213.515167,201.630630 207.988846,206.355194
				C206.055634,208.397430 204.580795,209.988373 203.105957,211.579315
				C200.248581,215.036346 197.391190,218.493362 194.165100,222.447403
				C193.050858,224.032715 192.305328,225.120987 191.559799,226.209259
				C183.939102,236.097809 179.046906,247.309082 175.412659,259.867981
				C175.111603,261.331573 174.962463,262.131073 174.813324,262.930573
				C173.869492,268.339294 172.925659,273.747986 171.888489,279.958557
				C171.908615,284.840973 172.022049,288.921478 172.135498,293.002014
				C172.620956,297.097687 173.106415,301.193390 173.712921,306.011322
				C174.370178,308.536652 174.906418,310.339752 175.442642,312.142822
				C178.280579,325.425323 184.239059,337.277924 192.342804,348.802307
				C193.239578,349.978516 193.804214,350.652130 194.368866,351.325745
				C196.711166,354.449402 199.053467,357.573090 201.841003,361.149689
				C213.058670,373.980774 225.851151,383.871826 239.930740,392.178223
				C241.169006,393.045197 242.407272,393.912170 243.940948,395.189514
				C244.178833,395.787354 244.121307,395.974854 244.063782,396.162323
				C238.328659,395.908112 232.593552,395.653931 226.031647,395.391785
				C223.802292,395.299591 222.399704,395.215363 220.997131,395.131134
				C216.611893,394.501495 212.226654,393.871887 207.120941,393.133057
				C205.957199,392.951202 205.513931,392.878571 205.070663,392.805908
				C198.312500,391.261871 191.554352,389.717804 184.059387,387.983429
				C182.285873,387.599518 181.249161,387.405945 180.212448,387.212402
				C162.710037,380.190857 145.207626,373.169281 127.134369,365.835571
				C124.374580,364.352173 122.185631,363.180939 119.996681,362.009735
				C113.192909,357.758514 106.389145,353.507263 99.061317,348.880615
				C96.690689,347.378204 94.844116,346.251221 92.997543,345.124237
				C72.740128,329.164703 53.603939,312.067841 37.635715,291.639954
				C34.937923,288.188721 34.638454,286.078888 37.586075,282.421631
				C63.208088,250.631027 93.850349,224.976334 130.077972,206.129288
				C154.123383,193.619934 179.592682,185.150909 206.995270,180.274124
				C208.850830,179.951660 209.995605,179.743500 211.140396,179.535339
				C213.568985,179.295532 215.997574,179.055725 219.223587,178.660706
				C222.014755,178.296158 224.008514,178.086853 226.002258,177.877563
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M240.008331,391.826843
				C225.851151,383.871826 213.058670,373.980774 202.139084,361.302856
				C204.646469,359.718475 206.863647,358.514130 210.069473,360.875763
				C212.203857,362.448059 215.824463,362.002808 218.947861,362.486572
				C217.461105,356.819641 216.213455,352.064087 215.085739,346.956421
				C223.321671,353.897705 231.437653,361.191040 239.747406,368.752686
				C236.262863,372.461700 233.151199,370.670563 229.837173,368.207764
				C228.070999,366.895233 225.792923,366.271545 223.745895,365.336945
				C223.442139,365.896698 223.138382,366.456421 222.834625,367.016174
				C227.965683,373.116425 233.227295,379.114502 238.136200,385.388580
				C239.367661,386.962524 239.466537,389.422638 240.008331,391.826843
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M202.093979,328.883301
				C205.434219,333.101837 208.635651,337.717224 211.959839,342.650452
				C203.122986,342.585083 199.954422,338.302460 202.093979,328.883301
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M244.001678,372.166107
				C247.911148,373.998840 251.757156,376.167511 255.823883,378.586670
				C251.036743,381.904419 244.107498,378.278381 244.001678,372.166107
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M172.467972,292.885406
				C172.022049,288.921478 171.908615,284.840973 171.924622,280.380646
				C177.091568,283.770752 177.392700,288.921936 172.467972,292.885406
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M283.019043,390.505280
				C286.440826,391.062469 289.884216,392.005524 293.664490,393.120178
				C293.315338,396.672577 290.942444,396.543854 288.283783,396.196381
				C285.072998,395.776794 283.038574,394.391357 283.019043,390.505280
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M195.208527,313.134094
				C196.775757,315.949585 197.980927,318.878754 199.252182,322.147614
				C196.091431,324.226929 194.285019,322.208649 193.017487,319.781708
				C191.688461,317.237030 191.539536,314.666138 195.208527,313.134094
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M297.962250,185.695618
				C295.498627,185.334564 292.998932,184.598633 290.190460,183.706223
				C290.711700,181.992249 291.585175,179.083191 292.364319,179.108231
				C295.983704,179.224625 297.495087,181.948471 297.962250,185.695618
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M223.044159,218.275024
				C221.549744,220.309418 219.843719,222.112976 217.885773,224.090851
				C216.947876,223.073547 215.511871,220.976990 215.690704,220.828751
				C217.717361,219.149048 219.098206,215.318680 223.044159,218.275024
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M314.145844,192.487183
				C312.115509,191.896759 310.220703,191.036804 308.062439,190.026672
				C308.499451,187.195984 309.973969,185.897247 312.816681,187.093292
				C315.420807,188.188950 315.623230,189.986343 314.145844,192.487183
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M331.955139,202.908844
				C329.859589,201.977112 327.983337,200.827652 325.909180,199.409134
				C327.843994,199.047043 329.976685,198.954025 332.109406,198.860992
				C332.131073,200.137695 332.152771,201.414413 331.955139,202.908844
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M265.019165,383.622559
				C266.832886,384.046417 268.672485,384.833313 270.747284,385.855896
				C269.891602,386.826355 268.800720,387.561127 267.709839,388.295898
				C266.821564,386.859100 265.933319,385.422333 265.019165,383.622559
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M120.035294,362.381104
				C122.185631,363.180939 124.374580,364.352173 126.777176,365.783081
				C122.791138,368.519165 121.712387,368.006012 120.035294,362.381104
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M221.029144,395.489624
				C222.399704,395.215363 223.802292,395.299591 225.614410,395.485443
				C225.264847,397.068909 224.505737,398.550751 223.746643,400.032593
				C222.851486,398.637787 221.956329,397.242950 221.029144,395.489624
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M225.911133,177.544174
				C224.008514,178.086853 222.014755,178.296158 219.591858,178.507980
				C220.085464,177.174805 221.008240,175.839096 221.931000,174.503403
				C223.227341,175.405869 224.523666,176.308334 225.911133,177.544174
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M175.767517,312.039673
				C174.906418,310.339752 174.370178,308.536652 173.877060,306.367615
				C178.866333,307.989990 179.173676,308.829742 175.767517,312.039673
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M280.908691,183.786438
				C279.580688,184.724838 278.133667,185.354340 276.343628,186.007217
				C277.011353,180.901459 277.474457,180.654572 280.908691,183.786438
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M251.155914,197.404724
				C250.704788,198.144653 250.138351,198.545639 249.312347,198.984482
				C248.546844,197.737732 248.040894,196.453125 247.534943,195.168503
				C248.703506,195.800934 249.872070,196.433350 251.155914,197.404724
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M192.162933,273.221436
				C192.373077,274.837585 192.237198,276.511780 191.998901,278.593811
				C187.769012,276.469818 187.758514,275.714844 192.162933,273.221436
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M191.704453,297.195618
				C192.291946,298.746704 192.623642,300.493530 193.006500,302.619568
				C188.703339,302.225220 188.921814,300.139465 191.704453,297.195618
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M203.508087,211.580048
				C204.580795,209.988373 206.055634,208.397430 207.798599,206.649597
				C209.862534,210.787567 206.798264,211.112198 203.508087,211.580048
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M191.804321,226.328232
				C192.305328,225.120987 193.050858,224.032715 194.020416,222.769653
				C195.198242,224.839722 195.509491,226.718323 191.804321,226.328232
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M223.815918,193.340363
				C224.539261,192.335373 225.427460,191.586670 226.592316,190.736176
				C226.619904,194.752197 226.521225,194.853394 223.815918,193.340363
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M93.105072,345.447937
				C94.844116,346.251221 96.690689,347.378204 98.731239,348.765442
				C97.021011,347.941010 95.116806,346.856354 93.105072,345.447937
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M210.966217,179.275696
				C209.995605,179.743500 208.850830,179.951660 207.354034,180.116486
				C207.781509,177.986023 208.821060,176.831299 210.966217,179.275696
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M180.263748,387.547729
				C181.249161,387.405945 182.285873,387.599518 183.662796,388.004700
				C182.499435,391.140045 181.281113,390.907196 180.263748,387.547729
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M194.520416,351.077545
				C193.804214,350.652130 193.239578,349.978516 192.595001,349.051758
				C194.831787,347.778503 195.563828,348.441498 194.520416,351.077545
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M231.704681,174.974243
				C232.243668,174.809738 232.772141,174.802048 233.300629,174.794373
				C233.291489,174.943039 233.282349,175.091690 233.273193,175.240356
				C232.746841,175.203918 232.220505,175.167496 231.704681,174.974243
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M175.113724,262.882751
				C174.962463,262.131073 175.111603,261.331573 175.415100,260.265930
				C176.208084,260.411438 176.846664,260.823090 177.485260,261.234802
				C176.794891,261.768188 176.104507,262.301575 175.113724,262.882751
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M208.292664,235.257416
				C208.077011,236.082443 207.570755,236.988358 206.835968,238.108521
				C207.072311,237.327957 207.537170,236.333130 208.292664,235.257416
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M205.112152,393.031067
				C205.513931,392.878571 205.957199,392.951202 206.703491,393.176514
				C206.610367,393.683624 206.214203,394.038086 205.818039,394.392548
				C205.596573,394.013763 205.375107,393.635010 205.112152,393.031067
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M241.860733,199.682373
				C241.848267,199.493484 241.896484,199.358887 241.944687,199.224274
				C242.051636,199.315659 242.158600,199.407043 242.265564,199.498428
				C242.150864,199.577835 242.036148,199.657257 241.860733,199.682373
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M244.195770,396.180389
				C244.121307,395.974854 244.178833,395.787354 244.247681,395.305969
				C244.281921,395.407532 244.304840,395.803009 244.195770,396.180389
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M345.969299,194.940308
				C345.994141,194.920441 345.944489,194.960159 345.969299,194.940308
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M434.863007,183.128632
				C434.029327,183.592972 433.217133,183.827393 432.404968,184.061798
				C432.442261,183.485870 432.479584,182.909943 432.516907,182.334000
				C433.306122,182.522232 434.095306,182.710464 434.863007,183.128632
			z"/>
			<path fill="#A7AEAE" opacity="1.000000" stroke="none"
				d="
			M447.088562,190.262589
				C447.703217,189.890625 448.309631,189.724426 448.916046,189.558258
				C448.911316,189.995163 448.906616,190.432068 448.901917,190.868973
				C448.294708,190.735443 447.687500,190.601898 447.088562,190.262589
			z"/>
			<path fill="#828689" opacity="1.000000" stroke="none"
				d="
			M335.085754,172.945190
				C334.805359,172.896957 334.503906,172.885117 334.215424,172.817673
				C334.144348,172.801071 334.115601,172.603439 334.067383,172.489029
				C334.323792,172.574860 334.580170,172.660690 334.940399,172.871979
				C335.044220,172.997421 335.069489,172.961060 335.085754,172.945190
			z"/>
		</svg>
  );
}
